'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const paragraphs = document.querySelectorAll('.paragraph-with-load-more');

  paragraphs.forEach((paragraph) => {
    const limit = paragraph.querySelector('.paragraph-limit');
    const content = paragraph.querySelector('.paragraph-content');

    if(content.offsetHeight > limit.offsetHeight) {
      const readMoreBtn = paragraph.querySelector('button');
      const gradient = paragraph.querySelector('.gradient-layer');

      gradient.classList.remove('d-none');
      readMoreBtn.classList.remove('d-none');

      readMoreBtn.addEventListener('click', () => {
        limit.classList.toggle('is-visible');
        readMoreBtn.classList.toggle('show-less');
        gradient.classList.toggle('d-none');
      });

    }

  });

});
